/** 与 Ant Design lg 断点对齐：< 992px 视为手机/小平板 */
export const MOBILE_MAX_WIDTH = 991;

export const MOBILE_MEDIA_QUERY = `(max-width: ${MOBILE_MAX_WIDTH}px)`;

/** 当前视口是否为手机宽度 */
export const isMobileViewport = () => {
    if (typeof window === 'undefined' || !window.matchMedia) {
        return false;
    }
    return window.matchMedia(MOBILE_MEDIA_QUERY).matches;
};

/** Drawer 宽度：手机全宽，桌面保持原值 */
export const drawerWidth = (desktopWidth, { mobile = '100%' } = {}) =>
    isMobileViewport() ? mobile : desktopWidth;

/** Modal 宽度：手机留边距，桌面保持原值 */
export const modalWidth = (desktopWidth) =>
    isMobileViewport() ? 'calc(100vw - 32px)' : desktopWidth;

/** Descriptions 响应式列数 */
export const descriptionColumns = { xs: 1, sm: 2, md: 3 };
